module.exports = __webpack_public_path__ + "img/estaca-ferroviaria.8e61abb5.jpg";